/**
 * SHA-256 hash of the canonical localization bundle shipped with this build.
 *
 * The hash is read from packages/i18n/bundle_hash.txt (written by the backend
 * BundleExportService) via the auto-generated bundledHash.ts file. Regenerate
 * it by running: yarn workspace @chinese-vendor/i18n codegen:hash
 *
 * How it is used:
 *   1. The app ships with BUNDLED_LOCALIZATION_HASH baked in.
 *   2. Every API response optionally carries `localization_hash` (the SHA-256
 *      of the latest bundle version in the database).
 *   3. The frontend compares the two hashes; a mismatch triggers a fresh fetch
 *      of the localization bundle from the API.
 *
 * To update: re-run the localization bundle export (backend BundleExportService
 * or the localization_bundle_cli). bundledHash.ts is auto-regenerated.
 */
export { BUNDLED_LOCALIZATION_HASH } from './bundledHash';
